import { IGetUploadedAssetsResponse, IUploadedAsset } from '../interfaces/assets.interface';
import { IBrand } from '../interfaces/brand.interface';
import { AddUploadedAsset, LoadMoreAssets, SetAssetsPage } from '../store/slice/assets.slice';
import { extractKeyFromS3url } from './common.utils';

export const fetchMoreAssets = async (
    activeBrand: IBrand | null,
    assetsHasNext: boolean,
    fetchUploadedAssets: any,
    assetsPage: number,
    dispatch: any,
) => {
    if (!activeBrand) return;
    if (!assetsHasNext) return;

    const response = await fetchUploadedAssets({
        page: assetsPage + 1,
        brandId: activeBrand.id,
    });
    const uploadedAssetsResponse: IGetUploadedAssetsResponse | undefined = response.data;
    if (!uploadedAssetsResponse) {
        return;
    }
    const uploadedAssets: IUploadedAsset[] = uploadedAssetsResponse.records.map((image) => ({
        ...image,
        isSelected: false,
    }));
    dispatch(SetAssetsPage(assetsPage + 1));
    dispatch(LoadMoreAssets({ assets: uploadedAssets, hasNext: uploadedAssetsResponse.hasNext }));
};

export const addUploadedAssetToStore = (data: any, dispatch: any) => {
    const imageUrl = data.image;
    dispatch(
        AddUploadedAsset({
            id: data.id,
            name: extractKeyFromS3url(imageUrl) || '',
            assets: imageUrl,
            isSelected: false,
        }),
    );
};
